import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component ExpensePlusIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <ExpensePlusIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <ExpensePlusIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ExpensePlusIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-testid="ExpensePlusIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M20 21a2 2 0 0 0 1.994-1.85L22 19v-7h-2v7H4V5h8V3H4a2 2 0 0 0-1.995 1.85L2 5v14c0 1.06.81 1.919 1.85 1.994L4 21z"
        clipRule="evenodd"
      />
      <path d="M11 8V7H9v1H8l-.117.007A1 1 0 0 0 7 9v3l.007.117A1 1 0 0 0 8 13h3v1H7v2h2v1h2v-1h1l.117-.007A1 1 0 0 0 13 15v-3l-.007-.117A1 1 0 0 0 12 11H9v-1h4V8zm8.057-3.943c.17.61.53 1.282 1.096 1.848A4.3 4.3 0 0 0 22 7.001c-.61.17-1.281.529-1.847 1.095a4.3 4.3 0 0 0-1.095 1.846 4.3 4.3 0 0 0-1.096-1.846A4.3 4.3 0 0 0 16.114 7a4.3 4.3 0 0 0 1.848-1.095 4.3 4.3 0 0 0 1.095-1.848m-2.943-2.412c.079.28.244.59.505.851.26.26.57.426.85.504a2 2 0 0 0-.85.505c-.26.26-.426.57-.505.85a2 2 0 0 0-.504-.85A2 2 0 0 0 14.76 3c.28-.078.59-.243.85-.504.26-.26.426-.57.504-.85Z" />
    </svg>
  )
);
ExpensePlusIcon.displayName = "ExpensePlusIcon";
export default ExpensePlusIcon;
